export const contactsData = {
  email: "ghimireutsav11@gmail.com",
  phone: "Hidden",
  address: "Available for remote roles",
  sheetAPI: "https://sheetdb.io/api/v1/d4wiin5po0bha",
};
